import React from "react";
import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";
import { ButtonType } from "./dataHistory.styled";
import { TYPE_ALMOND, TYPE_ENTAMADO, TYPE_LAGAR } from "../../../constants";
import Select from "react-select";

const DetailDataHistoryView = (props) => {
  const { t } = useTranslation();

  const { onSelectType, typeSelected, onYearsSelection, yearsSelection } =
    props;

  const actualYear = new Date().getFullYear();

  const options = Array.from({ length: 10 }, (_, i) => {
    const year = actualYear - i;
    return { value: year, label: year.toString() };
  });

  return (
    <>
      <div className="row justify-content-between align-items-center mt-5 mb-5">
        <div className="col">
          <h3 className="title">{t("dataHistory")}</h3>
        </div>
        <div className="col-2">
          <label className="control-label mandatory">
            {t("forms.upload.labels.year")}
          </label>
          <Select
            id="year"
            name="year"
            value={options.find((opt) => opt.value === yearsSelection)}
            onChange={(value) => {
              onYearsSelection(value);
            }}
            options={options}
            classNamePrefix="dark"
            placeholder=""
          />
        </div>
        <div className="col d-flex justify-content-end">
          <ButtonType
            type="button"
            $isSelected={typeSelected === TYPE_ALMOND.code}
            onClick={() => onSelectType(TYPE_ALMOND.code)}
          >
            Almendra
          </ButtonType>
          <ButtonType
            type="button"
            $isSelected={typeSelected === TYPE_ENTAMADO.code}
            onClick={() => onSelectType(TYPE_ENTAMADO.code)}
          >
            Entamadora
          </ButtonType>
          <ButtonType
            type="button"
            $isSelected={typeSelected === TYPE_LAGAR.code}
            onClick={() => onSelectType(TYPE_LAGAR.code)}
          >
            Lagar
          </ButtonType>
        </div>
      </div>
    </>
  );
};

DetailDataHistoryView.propTypes = {
  data: PropTypes.any,
};

export default DetailDataHistoryView;
